export * from './mocks'
export * from './utils'
export * from './icons'
export * from './day'

export type Slug =
  | 'default'
  | 'football'
  | 'basketbol'
  | 'swimming'
  | 'sportivnoe-plavanie'
  | 'boxing'
  | 'gymnastics'
  | 'xokkei'
  | 'saxmaty'
  | 'tancy'
  | 'tennis'
  | 'badminton'
  | 'beg'
  | 'voleibol'
  | 'golf'
  | 'snorkling'
  | string
  | undefined

export const SLUG_CARD_COLORS = {
  default: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  football: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  basketbol: 'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  swimming: 'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  'sportivnoe-plavanie': 'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
  boxing:
    'linear-gradient(180deg, rgba(255, 157, 157, 0.5) 0%, rgba(255, 134, 59, 0.5) 100%)',
  gymnastics: 'linear-gradient(257.06deg, #9DD1FC 14.04%, #6BA8DA 88.7%)',
  xokkei: 'linear-gradient(180deg, #FFDDC4 0%, #FFAF76 100%)',
  saxmaty:
    'linear-gradient(180deg, rgba(255, 235, 157, 0.5) 0%, rgba(255, 216, 59, 0.5) 100%)',
  tancy: 'linear-gradient(180deg, #89DDDA 0%, #1E8380 100%)',
  tennis:
    'linear-gradient(145.93deg, rgba(233, 166, 40, 0.2) 25.96%, rgba(233, 166, 40, 0.6) 79.75%)',
  badminton:
    'linear-gradient(72.05deg, rgba(83, 123, 159, 0.3) 17.87%, rgba(83, 123, 159, 0.6) 87.71%)',
  beg: 'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  voleibol: 'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  golf: 'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  snorkling: 'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
}

export const DIRECTION_CARD_COLORS: string[] = [
  'linear-gradient(41.08deg, #9BE68C 11.79%, #42BE54 76.62%)',
  'linear-gradient(180deg, #278EE0 0%, #C3E4FF 100%)',
  'linear-gradient(180deg, #FFE0DB 0%, #FFEAE8 100%)',
  'linear-gradient(180deg, #A3D6FF 0%, #63A9E0 100%)',
  'linear-gradient(180deg, rgba(255, 157, 157, 0.5) 0%, rgba(255, 134, 59, 0.5) 100%)',
  'linear-gradient(257.06deg, #9DD1FC 14.04%, #6BA8DA 88.7%)',
  'linear-gradient(180deg, #FFDDC4 0%, #FFAF76 100%)',
  'linear-gradient(180deg, rgba(255, 235, 157, 0.5) 0%, rgba(255, 216, 59, 0.5) 100%)',
  'linear-gradient(180deg, #89DDDA 0%, #1E8380 100%)',
  'linear-gradient(145.93deg, rgba(233, 166, 40, 0.2) 25.96%, rgba(233, 166, 40, 0.6) 79.75%)',
  'linear-gradient(72.05deg, rgba(83, 123, 159, 0.3) 17.87%, rgba(83, 123, 159, 0.6) 87.71%)',
]

export function getReadingTime(text: string) {
  const wordsPerMinute = 225 // Average adult reading speed
  const words = text.trim().split(/\s+/).length // Split by spaces to count words
  const time = Math.ceil(words / wordsPerMinute) // Round up to the nearest minute

  return `${time} мин`
}

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text)
    console.log('Скопировано в буфер обмена!')
  } catch (error) {
    console.error('Произошла ошибка при копировании: ', error)
  }
}

/**
 * Склонение числительных в русском языке.
 * @example declOfNum(1, ['яблоко', 'яблока', 'яблок']) // 'яблоко'
 * @example declOfNum(2, ['яблоко', 'яблока', 'яблок']) // 'яблока'
 * @example declOfNum(5, ['яблоко', 'яблока', 'яблок']) // 'яблок'
 */
export function declOfNum(
  number: number = 0,
  titles: [string, string, string],
): string {
  const cases = [2, 0, 1, 1, 1, 2] as const
  const index =
    number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]!
  return titles[index]
}

/**
 * Склонение числительного с выводом числа и единицы измерения.
 * @example declOfNumWithVal(1, ['яблоко', 'яблока', 'яблок']) // '1 яблоко'
 * @example declOfNumWithVal(3, ['яблоко', 'яблока', 'яблок']) // '3 яблока'
 * @example declOfNumWithVal(7, ['яблоко', 'яблока', 'яблок']) // '7 яблок'
 */
export function declOfNumWithVal(
  number: number = 0,
  titles: [string, string, string],
): string {
  return `${number} ${declOfNum(number, titles)}`
}
